<template>
  <b-container class="pb-3">
    <!-- Pre-verification -->
    <b-card v-if="!validated && !error" class="ev-card">
      <div class="ev-icon-wrap mb-2">
        <feather-icon icon="MailIcon" size="48" class="ev-icon" />
      </div>
      <h3 class="ev-title">Confirm Your Email Address</h3>
      <p class="ev-text">
        Thank you for registering. To continue with your application, we need to verify your email address.
        Please click the button below to complete the verification.
      </p>
      <p class="ev-text">
        If you did not request this, you can safely ignore this page.
      </p>
      <div class="d-flex justify-content-center mt-2">
        <b-button variant="primary" @click="verificationClicked">
          Confirm Email Address
        </b-button>
      </div>
    </b-card>

    <!-- Automatic approval -->
    <b-card v-else-if="validated && automaticApproval && !error" class="ev-card">
      <div class="ev-icon-wrap mb-2">
        <feather-icon icon="CheckCircleIcon" size="48" class="ev-icon ev-icon--success" />
      </div>
      <h3 class="ev-title">Application Accepted</h3>
      <p class="ev-text">
        Your email address has been verified and your account has been set up. We have sent you an email
        with your login details.
      </p>
      <div class="ev-note">
        <feather-icon icon="InfoIcon" size="14" class="mr-50" />
        Didn't receive the email? Check your spam folder or contact support.
      </div>
    </b-card>

    <!-- Cap hit -->
    <b-card v-else-if="validated && caphit && !error" class="ev-card">
      <div class="ev-icon-wrap mb-2">
        <feather-icon icon="SlashIcon" size="48" class="ev-icon ev-icon--warning" />
      </div>
      <h3 class="ev-title">Registration Unavailable</h3>
      <p class="ev-text">
        Unfortunately we are unable to accept your application at this time.
      </p>
      <p class="ev-text">{{ companytext }}</p>
      <p class="ev-text">
        If you believe this is an error, please contact us.
      </p>
    </b-card>

    <!-- Manual approval -->
    <b-card v-else-if="validated && manualApproval && !error" class="ev-card">
      <div class="ev-icon-wrap mb-2">
        <feather-icon icon="ClockIcon" size="48" class="ev-icon ev-icon--pending" />
      </div>
      <h3 class="ev-title">Application Under Review</h3>
      <p class="ev-text">
        Your email address has been verified. Your application is now being reviewed by our team and
        you will receive an email once a decision has been made.
      </p>
      <div class="ev-note">
        <feather-icon icon="InfoIcon" size="14" class="mr-50" />
        This typically takes two business days.
      </div>
    </b-card>

    <!-- Error -->
    <b-card v-else class="ev-card">
      <div class="ev-icon-wrap mb-2">
        <feather-icon icon="AlertCircleIcon" size="48" class="ev-icon ev-icon--error" />
      </div>
      <h3 class="ev-title">Something Went Wrong</h3>
      <p class="ev-text">{{ errorMessage }}</p>
    </b-card>
  </b-container>
</template>

<script>
import { BCard, BButton, BContainer } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BButton,
    BContainer,
  },
  data() {
    return {
      verificationpassword: '',
      validated: false,
      automaticApproval: false,
      manualApproval: false,
      error: false,
      errorMessage: '',
      caphit: false,
      companytext: '',
    }
  },
  created() {
    if (!this.$route.query.ref) {
      this.$router.replace({ name: 'error-404' })
    } else {
      this.verificationpassword = this.$route.query.ref
    }
  },
  methods: {
    verificationClicked() {
      this.$http.get('userregistration.cfc', {
        params: {
          method: 'emailVerification',
          verificationpassword: this.verificationpassword,
        },
      })
        .then(response => {
          if (response.data.status) {
            this.validated = true
            this.manualApproval = response.data.manual
            this.automaticApproval = response.data.automatic
            if ('message' in response.data) {
              this.caphit = true
              this.companytext = response.data.message
            }
          } else {
            this.errorMessage = response.data.message
            this.error = true
          }
        })
        .catch(() => {
          this.error = true
          this.errorMessage = 'An unexpected error occurred. Please try again.'
        })
    },
  },
}
</script>

<style scoped>
.ev-card {
  max-width: 600px;
  margin: 2rem auto 0;
  text-align: center;
}

.ev-icon-wrap {
  display: flex;
  justify-content: center;
}

.ev-icon {
  color: var(--primary);
}

.ev-icon--success {
  color: #28c76f;
}

.ev-icon--warning {
  color: #ff9f43;
}

.ev-icon--pending {
  color: #00cfe8;
}

.ev-icon--error {
  color: #ea5455;
}

.ev-title {
  font-size: 1.375rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.ev-text {
  font-size: 0.9rem;
  line-height: 1.7;
  margin-bottom: 0.5rem;
}

.ev-note {
  display: inline-flex;
  align-items: center;
  background: #f0f4ff;
  border: 1px solid #d5d9f0;
  border-radius: 6px;
  padding: 0.6rem 1rem;
  font-size: 0.8rem;
  margin-top: 0.75rem;
}
</style>
